/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type Login_AccountQueryVariables = {};
export type Login_AccountQueryResponse = {
    readonly viewer: {
        readonly userAccounts: ReadonlyArray<{
            readonly id: string;
        }> | null;
    } | null;
};
export type Login_AccountQuery = {
    readonly response: Login_AccountQueryResponse;
    readonly variables: Login_AccountQueryVariables;
};



/*
query Login_AccountQuery {
  viewer {
    userAccounts {
      id
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "Account",
  "kind": "LinkedField",
  "name": "userAccounts",
  "plural": true,
  "selections": [
    (v0/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "Login_AccountQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "Login_AccountQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "827ed49837f706b5c6a58cc63e64eef7",
    "id": null,
    "metadata": {},
    "name": "Login_AccountQuery",
    "operationKind": "query",
    "text": "query Login_AccountQuery {\n  viewer {\n    userAccounts {\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f26d686bbddab5943440aafc189b56bf';
export default node;
